export default "__VITE_ASSET__pONK2bnt__"